module.exports = __webpack_public_path__ + "static/media/stop-timer.d3eb0fd3.svg";